import React, { memo } from 'react';
import { Button, Dialog, Grid, styled, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export interface Props {
  snackBarOpen: boolean;
  setSnackBarOpen: any;
  snackbarSeverity: string;
  snackBarMessage: string;
  isClickContinue?: any;
}

const SnackBar = (prop: Props) => {

  //this method only used to navigation in viewLeave page
  const navigation = (data) => {
    if(prop.isClickContinue){
      prop.isClickContinue(data)
    }
  };
  
  const handleClose = () => {

    prop.setSnackBarOpen(false);
    navigation(true);
  };

  const StyledButton = styled(Button)`
    &:hover {
      background: ${prop.snackbarSeverity === 'success' ? '#00b26a' : '#ed1c24'};
    }
  `;

  return (
    <Dialog
      open={prop.snackBarOpen}
      keepMounted
      fullWidth
      scroll="paper"
      onClose={handleClose}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '20rem'
          }
        },
        zIndex: '10000'
      }}
    >
      <Grid
        item
        sx={{
          p: '1rem',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
        xs={12}
      >
        {prop.snackbarSeverity === 'success' ? (
          <CheckCircleIcon
            sx={{ alignSelf: 'center', color: '#00b26a', fontSize: '4rem' }}
          />
        ) : (
          <CancelIcon
            sx={{ alignSelf: 'center', color: '#ed1c24', fontSize: '4rem' }}
          />
        )}
        <Typography
          sx={{
            fontSize: '1rem',
            alignSelf: 'center',
            // textTransform: 'capitalize',
            color: `${prop.snackbarSeverity === 'success' ? '#00b26a' : '#ed1c24'}`,
            fontWeight: 'bold',
            mb: '0.25rem'
          }}
        >
          {prop.snackbarSeverity}
        </Typography>
        <Typography
          sx={{
            fontSize: '0.8rem',
            color: '#919191',
            alignSelf: 'center',
            textAlign: 'center',
            whiteSpace: 'pre-line',
            maxHeight: '12rem',
            overflowY: 'auto',
            width: '100%'
          }}
        >
          {prop.snackBarMessage}
        </Typography>
        <StyledButton
          id="btn-handleClose-1"
          onClick={handleClose}
          variant="contained"
          sx={{
            m: '1rem',
            px: '3rem',
            alignSelf: 'center',
            width: '10%',
            fontSize: '13px',
            fontWeight: 'normal',
            background: `${
              prop.snackbarSeverity === 'success' ? '#00b26a' : '#ed1c24'
            }`,
            color: '#ffffff'
          }}
        >
          Continue
        </StyledButton>
      </Grid>
    </Dialog>
    // <Snackbar
    //   style={{ zIndex: '10000' }}
    //   open={snackBarOpen}
    //   autoHideDuration={2000}
    //   onClose={handleClose}
    // >
    //   <Alert variant="filled" severity={snackbarSeverity as AlertColor}>
    //     {snackBarMessage}
    //     <IconButton
    //       size="small"
    //       aria-label="close"
    //       color="inherit"
    //       onClick={handleClose}
    //     >
    //       <CloseIcon fontSize="small" />
    //     </IconButton>
    //   </Alert>
    // </Snackbar>
  );
};

export default memo(SnackBar);
